import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';

const Layout = () => {
  const location = useLocation();

  // Define the paths where you DON'T want the header to show
  const hideHeaderRoutes = [
    '/reservation/options/booking/welcome',
    '/reservation/options/update-checkout-date',
    '/reservation/options/update-room-type',
    '/reservation/options/booking/welcome/paid-amenities',
    '/reservation/options/booking/welcome/room-service',
    '/reservation/options/booking/welcome/food-service',
    '/reservation/options/booking/welcome/food-service/succesful',
    '/amenities-payment-succesful',
    '/roomservice-payment-succesful',
  ]; // example routes

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <div className="flex flex-col ">
      {!shouldHideHeader && <Header />}
      <main className="flex-grow">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;

// import React from "react";
// import { Outlet } from "react-router-dom";
// import Header from "./Header";

// const Layout = () => {
//   return (
//     <div className="flex flex-col "> {/* Set page background */}
//       <Header />
//       <main className="flex-grow"> {/* Add padding to prevent overlap */}
//         <Outlet />
//       </main>
//     </div>
//   );
// };

// export default Layout;
